import { NoParamEndpointConstructor } from 'interfaces/api.interfaces'

interface Endpoints {
  login: NoParamEndpointConstructor
}

export const authEndpoints: Endpoints = {
  login: () => '/login',
}
